import React from 'react';
import { useAppSelector } from '../../hooks';

const Video: React.FC = () => {
    const src = useAppSelector(state => state.layer.src);
    return (
        <div className='movie'>
            <video
                autoPlay
                loop
                style={{width: "100%"}}
                muted
                src={src}
            >
			</video>
        </div>
    )
}

export default Video;